import { use } from 'react';
import { loadAdminDependencies } from 'AssetLoader';

let adminDependenciesPromise: Promise<void> | null = null;

function getGlobalAdminDependenciesPromise(): Promise<void> {
    if (!adminDependenciesPromise) {
        adminDependenciesPromise = loadAdminDependencies();
    }
    return adminDependenciesPromise;
}

/**
 * Suspense-enabled hook to load admin dependencies using React 19's `use` hook.
 * Pure JavaScript implementation without Angular dependencies.
 *
 * This hook will suspend (throw a promise) while dependencies are loading,
 * which requires the component to be wrapped in a <Suspense> boundary.
 *
 * Note: This hook only handles asset loading, not permission checking.
 * Permission checking should be done at the route level via ProtectedRoute.
 *
 * @throws {Promise<void>} When dependencies are still loading (suspends)
 * @throws {Error} When dependency loading fails
 */
export function useLoadAdminDependencies(): void {
    // React 19's `use` hook handles the suspense automatically
    use(getGlobalAdminDependenciesPromise());
}
